import { IAllSuppliers } from 'src/services/useGetOnlineAndOfflineSuppliers';

export interface ResolveAutoSelectedSupplierParams {
  isPoConfirmed: boolean;
  poMatchedSuppliers: IAllSuppliers[];
  supplierNameValue: string;
  ocrMatchSupplier?: IAllSuppliers;
  possibleSharedSupplier: IAllSuppliers[];
  defaultSupplier: IAllSuppliers;
}

export const hasValidSupplierSelection = (supplier: IAllSuppliers): boolean =>
  Boolean(supplier.supplierId);

/**
 * Resolves supplier from validation data in priority order:
 * 1. Confirmed PO supplier
 * 2. OCR invoice supplier name match
 * 3. Single possible match from PO/document/supplier review
 */
export const resolveAutoSelectedSupplier = ({
  isPoConfirmed,
  poMatchedSuppliers,
  supplierNameValue,
  ocrMatchSupplier,
  possibleSharedSupplier,
  defaultSupplier,
}: ResolveAutoSelectedSupplierParams): IAllSuppliers => {
  if (isPoConfirmed && poMatchedSuppliers[0]) {
    return poMatchedSuppliers[0];
  }
  if (supplierNameValue && ocrMatchSupplier) {
    return ocrMatchSupplier;
  }
  if (possibleSharedSupplier.length === 1) {
    return possibleSharedSupplier[0];
  }
  return defaultSupplier;
};

/**
 * When PO or invoice validation re-runs, apply auto-pick when a source matches.
 * Otherwise keep the user's current confirm supplier selection.
 */
export const resolveSelectedSupplierAfterValidationChange = (
  autoSupplier: IAllSuppliers,
  currentSupplier: IAllSuppliers,
  isPoConfirmed: boolean,
  poMatchedSuppliers: IAllSuppliers[]
): IAllSuppliers => {
  if (isPoConfirmed && poMatchedSuppliers[0]) {
    return poMatchedSuppliers[0];
  }
  if (hasValidSupplierSelection(autoSupplier)) {
    return autoSupplier;
  }
  if (hasValidSupplierSelection(currentSupplier)) {
    return currentSupplier;
  }
  return autoSupplier;
};
